import { createSelector } from '@ngrx/store';
import { tagsFeature } from './tags.reducer';

export const selectTags = createSelector(tagsFeature.selectTags, tagsFeature.selectTagType, (tags, type) => (tags ? tags[type] : []));

const selectLinkedTags = createSelector(selectTags, tagsFeature.selectCurrentlyEditingEntityId, (tags, entityId) =>
  entityId ? tags.filter((tag) => tag.entities.some((entity) => entity.entityId === entityId)) : [],
);

export const selectNotUsedTags = createSelector(selectTags, selectLinkedTags, (tags, linkedTags) =>
  tags.filter((tag) => !linkedTags.some((linkedTag) => linkedTag.tagId === tag.tagId)),
);
